import keyMirror from 'keymirror';

export const questionModalActionTypes = keyMirror({
	SET_QUESTION_MODAL: null,

	GET_QUESTION_AVAILABLE_SUBJECTS: null,
	GET_QUESTION_AVAILABLE_SUBJECTS_SUCCESS: null,
	GET_QUESTION_AVAILABLE_SUBJECTS_ERROR: null,

	GET_QUESTION_AVAILABLE_TOPICS: null,
	GET_QUESTION_AVAILABLE_TOPICS_SUCCESS: null,
	GET_QUESTION_AVAILABLE_TOPICS_ERROR: null,

	CLEAR_QUESTION_AVAILABLE_TOPICS: null,

	UPLOAD_QUESTION_ATTACHMENT_REQUEST: null,
	UPLOAD_QUESTION_ATTACHMENT_SUCCESS: null,
	UPLOAD_QUESTION_ATTACHMENT_ERROR: null,

	CREATE_QUESTION_REQUEST: null,
	CREATE_QUESTION_SUCCESS: null,
	CREATE_QUESTION_ERROR: null,

	UPDATE_QUESTION_REQUEST: null,
	UPDATE_QUESTION_SUCCESS: null,
	UPDATE_QUESTION_ERROR: null,

	CLEAR_QUESTION_STATE: null,
});

export const MAX_ATTACHMENTS = 10;
